import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-prod-grps',
  templateUrl: './prod-grps.component.html',
  styleUrls: ['./prod-grps.component.css']
})
export class ProdGrpsComponent implements OnInit {
    public setting?: Setting;

    public itemsListProductGroups: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(916))[0];
    }

    private async loadProductGroups(): Promise<void> {
        this.itemsListProductGroups = await this.datatask.Post(915);
    }

    private async init() {
        this.loadSetting();
        this.loadProductGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
